import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  key: 1,
  class: "w-1/4"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "py-4"
};
const _hoisted_5 = {
  class: "d-flex mt-4"
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  class: "mb-4"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 3
};
const _hoisted_12 = {
  class: "mb-10"
};
import { reactive, onMounted, ref } from 'vue';
import axios from 'axios';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import Loader from '@/components/Loader.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import UpgradeDialog from '@/components/UpgradeDialog.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { pluralize } from '@/services/utils';
import RouteService from '@/services/RouteService';
export default {
  __name: 'NetDocsIntegration',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const {
      terms,
      features
    } = storeToRefs(useMeStore());
    const removeIntegrationDialog = ref(null);
    meStore.alerts = props.alerts;
    const upgradeModel = ref(undefined);
    const routeService = new RouteService(props);
    const state = reactive({
      settings: {},
      loading: true,
      connected: false,
      cabinets: [],
      netDocsIdCount: 0,
      isDisconnectedUnintentionally: false,
      form: {
        selectedCabinet: undefined,
        usePracticeArea: false
      }
    });
    onMounted(async () => {
      await Promise.all([meStore.getMe(), loadConfiguration()]);
    });
    async function loadConfiguration() {
      state.loading = true;
      try {
        const result = await axios.get('/documents/status');
        state.connected = result.data.connected;
        state.isDisconnectedUnintentionally = state.connected && result.data.isDisconnectedUnintentionally;
        state.netDocsIdCount = Number(result.data.netDocsIdCount) || 0;
        state.settings = result.data.settings;
        if (state.connected && !state.settings && !state.isDisconnectedUnintentionally) {
          await loadCabinets();
        }
      } catch (error) {
        props.alerts('Error loading configuration:', error);
      } finally {
        state.loading = false;
      }
    }
    async function loadCabinets() {
      const cabinetResult = await axios.get('/documents/cabinets');
      state.cabinets = cabinetResult.data;
      state.cabinets.forEach(cabinet => {
        cabinet.label = `${cabinet.name} (${cabinet.repositoryName})`;
      });
    }
    async function saveSettings() {
      await axios.put(`/documents/cabinets/${state.form.selectedCabinet.id}?usePracticeArea=${state.form.usePracticeArea}`);
      props.userService.reset();
      await loadConfiguration();
    }
    async function reconfigure() {
      await loadCabinets();
      state.form.selectedCabinet = state.cabinets.find(c => c.id === state.settings.cabinetId);
      state.form.usePracticeArea = state.settings.usePracticeArea;
      state.settings = null;
    }
    function download(cabinetId) {
      var url = '/v1/documents/export';
      if (cabinetId) {
        url += `?cabinetid=${cabinetId}`;
      }
      window.location.href = `${props.leanLawAuth.domain}${url}`;
    }
    function confirmRemoveIntegration() {
      removeIntegrationDialog.value.open().then(result => {
        if (result) {
          disconnect();
        }
      });
    }
    function connect() {
      if (!features.value.netdocs) {
        showUpgradeModal();
        return;
      }
      window.location.href = `${props.leanLawAuth.domain}/netdocs/connect?redirect=${encodeURIComponent(window.location.href)}`;
    }
    function disconnect() {
      window.location.href = `${props.leanLawAuth.domain}/netdocs/disconnect?redirect=${encodeURIComponent(window.location.href)}`;
      props.userService.reset();
    }
    const showUpgradeModal = () => {
      upgradeModel.value.open().then(result => {
        if (result) routeService.go('settings.company.maxioCompanySubscription');
      });
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[30] || (_cache[30] = _createElementVNode("img", {
        src: "/img/netdocs.png",
        alt: "NetDocs",
        class: "mx-auto",
        width: "200"
      }, null, -1)), state.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0
      })) : _createCommentVNode("", true), !state.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!state.connected ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[10] || (_cache[10] = _createElementVNode("p", null, " Connect to NetDocument to improve your workflows between your documents and LeanLaw. ", -1)), _createVNode(LlSecondaryButton, {
        variant: "flat",
        color: _unref(features).netdocs ? 'primary' : 'readonly-surface',
        onBtnClick: _cache[0] || (_cache[0] = $event => connect())
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Connect ", -1)]))]),
        _: 1
      }, 8, ["color"])])) : state.isDisconnectedUnintentionally ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[13] || (_cache[13] = _createElementVNode("p", {
        class: "text-lg mb-4"
      }, "NetDocuments is disconnected from LeanLaw.", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(LlSecondaryButton, {
        color: "primary",
        class: "mr-4",
        onClick: _cache[1] || (_cache[1] = $event => connect())
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Reconnect ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        onBtnClick: confirmRemoveIntegration,
        color: "error"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Remove Integration ", -1)]))]),
        _: 1
      })])])) : state.connected && !state.settings ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, " Pick the cabinet where documents are organized by clients and " + _toDisplayString(_unref(terms).matter) + "s. ", 1), _createElementVNode("div", _hoisted_7, [_createVNode(LlSelect, {
        "data-cy": "pick-cabinet",
        modelValue: state.form.selectedCabinet,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.selectedCabinet = $event),
        items: state.cabinets,
        placeholder: 'Pick Cabinet',
        labelClass: "remove-outline",
        "item-title": "label",
        "item-value": "id",
        clearable: "",
        searchable: "",
        isAutocomplete: true,
        "hide-details": true
      }, null, 8, ["modelValue", "items"])]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("p", null, [_createVNode(_component_v_icon, {
        color: "warning"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("mdi-alert", -1)]))]),
        _: 1
      }), _createTextVNode(" Your account has " + _toDisplayString(state.netDocsIdCount) + " " + _toDisplayString(_unref(pluralize)(state.netDocsIdCount, 'client')) + " and " + _toDisplayString(_unref(terms).matter) + " with a pre-configured link to a NetDocuments entity. If you connect to the wrong cabinet you might have " + _toDisplayString(_unref(terms).matter) + " that don't connect to NetDocuments correctly. Please contact LeanLaw support if you are not sure. ", 1)])], 512), [[_vShow, state.netDocsIdCount > 0]]), state.form.selectedCabinet ? (_openBlock(), _createElementBlock("div", _hoisted_8, [state.form.selectedCabinet.wsAttrPluralName ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("p", null, [_cache[15] || (_cache[15] = _createTextVNode(" Cabinet workspace attribute: ", -1)), _createElementVNode("b", null, _toDisplayString(state.form.selectedCabinet.wsAttrPluralName), 1)]), _createVNode(LlCheckbox, {
        "data-cy": "practice-area",
        modelValue: state.form.usePracticeArea,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.form.usePracticeArea = $event),
        label: "Use Practice Area"
      }, null, 8, ["modelValue"]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[4] || (_cache[4] = $event => download(state.form.selectedCabinet.id)),
        class: "px-12 py-2 mb-4 mr-4 mt-4 border bg-gray-100 hover:bg-gray-200 rounded text-gray-700"
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Download Client/Matter Report", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), !state.form.selectedCabinet.wsAttrPluralName ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("p", null, [_createVNode(_component_v_icon, {
        class: "mr-1",
        color: "warning"
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("mdi-alert", -1)]))]),
        _: 1
      }), _cache[18] || (_cache[18] = _createTextVNode(" This cabinet isn't organized by a profile attribute. Pick a cabinet that is organized by \"Matters\" or \"Cases\" that can be connected to clients and matters in LeanLaw. ", -1))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
        color: "primary",
        disabled: !state.form.selectedCabinet?.wsAttrPluralName,
        "data-cy": "activate-integration",
        class: "mt-4",
        onClick: _cache[5] || (_cache[5] = $event => saveSettings())
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" Activate Integration ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : state.connected && state.settings ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[28] || (_cache[28] = _createElementVNode("p", null, [_createElementVNode("span", {
        class: "fa fa-check-circle text-success"
      }), _createTextVNode(" LeanLaw is connected to NetDocuments ")], -1)), _createElementVNode("ul", _hoisted_12, [_createElementVNode("li", null, [_cache[20] || (_cache[20] = _createElementVNode("strong", null, "Repository:", -1)), _createTextVNode(" " + _toDisplayString(state.settings.repositoryId), 1)]), _createElementVNode("li", null, [_cache[21] || (_cache[21] = _createElementVNode("strong", null, "Cabinet:", -1)), _createTextVNode(" " + _toDisplayString(state.settings.cabinetId), 1)]), _createElementVNode("li", null, [_cache[22] || (_cache[22] = _createElementVNode("strong", null, "Client Attribute:", -1)), _createTextVNode(" " + _toDisplayString(state.settings.clientAttributeId), 1)]), _createElementVNode("li", null, [_cache[23] || (_cache[23] = _createElementVNode("strong", null, "Matter Attribute:", -1)), _createTextVNode(" " + _toDisplayString(state.settings.matterAttributeId), 1)]), _createElementVNode("li", null, [_cache[24] || (_cache[24] = _createElementVNode("strong", null, "Use Practice Area:", -1)), _createTextVNode(" " + _toDisplayString(state.settings.usePracticeArea), 1)])]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[6] || (_cache[6] = $event => download()),
        class: "px-12 py-2 mb-4 mr-4 border bg-gray-100 hover:bg-gray-200 rounded text-gray-700"
      }, {
        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("Download Client/Matter Report", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[7] || (_cache[7] = $event => reconfigure()),
        disabled: _ctx.saving,
        class: "px-12 py-2 mb-4 mr-4 border bg-gray-100 hover:bg-gray-200 rounded text-gray-700 text-"
      }, {
        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("Reconfigure", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[8] || (_cache[8] = $event => disconnect()),
        disabled: _ctx.saving,
        color: "error",
        class: "px-12 py-2 mr-4"
      }, {
        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("Disconnect", -1)]))]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(UpgradeDialog, {
        ref_key: "upgradeModel",
        ref: upgradeModel,
        title: "Upgrade to Pro or Elite Plans",
        "confirm-text": "Upgrade",
        "toggle-text": "Cancel"
      }, {
        message: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createElementVNode("div", null, [_createTextVNode(" The NetDocuments integration is available on Pro and Elite plans. See the full list of Pro and Elite perks "), _createElementVNode("a", {
          href: "https://www.leanlaw.co/pricing/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "here.")], -1)]))]),
        _: 1
      }, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "removeIntegrationDialog",
        ref: removeIntegrationDialog,
        title: "Remove NetDocuments Integration",
        message: "This will fully remove the NetDocuments integration from LeanLaw.",
        "toggle-text": "Cancel",
        "confirm-text": "Remove",
        "confirm-color": "error"
      }, null, 512)]);
    };
  }
};